import { createContext } from 'react';
import { ObjectRegion } from '../objectScreen.types';

export interface ObjectScreenContextValue {
  objectId: string;
  objectType: string;
  activeTab: string;
  setActiveTab: (tabKey: string) => void;
  regionTargets: Record<ObjectRegion, HTMLElement | null>;
  scrollParent: HTMLElement | null;
  stickyToolbar: HTMLElement | null;
  stickyFilterBar: HTMLElement | null;
  isDetailsOpen: boolean;
  detailsExpansionSteps: number;
}

export const ObjectScreenContext = createContext<ObjectScreenContextValue | null>(null);
